import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const CreateVMPGMappingForm = ({
  loading,
  vmLoading,
  vmList,
  corporateLoading,
  corporateList,
  gatewayLoading,
  paymentGatewayList,
  paymentConfigListLoading,
  paymentConfigList,
  onChangeOfCorporateId,
  onChangeOfPaymentConfig,
  onChangeOfPaymentGateway,
  onChangeOfVM,
  handleSubmit,
  handleBack
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
        <title> Vending Machine Payment Gateway Mapping </title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Vending Machine Payment Gateway Mapping
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Select Corporate</label>
            <Dropdown
              disabled={corporateLoading || loading}
              onChange={onChangeOfCorporateId}
              selection
              search
              options={corporateList || []}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Payment Gateway</label>
            <Dropdown
              disabled={gatewayLoading || loading}
              onChange={onChangeOfPaymentGateway}
              selection
              search
              options={paymentGatewayList || []}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Payment Config</label>
            <Dropdown
              disabled={paymentConfigListLoading || loading}
              onChange={onChangeOfPaymentConfig}
              selection
              search
              options={paymentConfigList || []}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Vending Machines</label>
            <Dropdown
              disabled={vmLoading || loading}
              onChange={onChangeOfVM}
              selection
              search
              multiple
              options={vmList || []}
            />
          </Form.Field>
          <Button
            loading={loading}
            onClick={handleSubmit}
            basic
            color="blue"
            style={{ float: 'right' }}
          >
            Save Mapping
          </Button>
          <Button
            loading={loading}
            onClick={handleBack}
            basic
            color="green"
            style={{ float: 'left' }}
          >
            Back to Listing
          </Button>
        </Form>
        <br />
        <br />
        <br />
        <br />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CreateVMPGMappingForm;



// WEBPACK FOOTER //
// ./src/Modules/VMPGMapping/component.jsx